// hooks/queries/useAlarmQuery.js

import { useQuery } from "@tanstack/react-query";
import { getUnAckAlarms } from "components/axios/alarmAxios";

const DELAY_TIME = Number(process.env.REACT_APP_DELAY_TIME) || 60000;

export const useAlarmQuery = ({
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["alarm-list"],
    queryFn: async () => {
      const categories = await getUnAckAlarms({intervalMinutes:5}); // 5분 동안 경보처리를 하지 않은 경우 경보 목록에 포함
      return { categories };
    },
    enabled,
    refetchInterval: DELAY_TIME,
    refetchIntervalInBackground: true,
    staleTime: 0,
    gcTime: 0,
    retry: 1,
  });
};